export default "__VITE_ASSET__DyT7MksE__"